import axios from 'axios'

export const getSimCards = async filtersQuery => {
    const response = await axios.get(
        `${process.env.API_URL}/sim-management${filtersQuery}`
    )
    return response.data
}

export const updateSimCardStatus = async payload => {
    const { simSerialNumber, ...rest } = payload
    const response = await axios.patch(
        `${process.env.API_URL}/sim-management/${simSerialNumber}`,
        rest
    )
    return response.data
}

export const getSimCardsBillingDetails = async () => {
    const response = await axios.get(
        `${process.env.API_URL}/sim-management/bill`
    )
    return response.data
}
